export default __webpack_public_path__ + "static/media/ic_radio.b3332f6d.svg";